import React from 'react';
import { Dialog, DialogContent, Box, Typography, IconButton, Stack, alpha } from '@mui/material';
import { Close as CloseIcon, EditNoteOutlined } from '@mui/icons-material';
import EditMeasurementForm from './EditMeasurementForm'; // Standardized the import name
import '../style.css';

const EditMeasurementModal = ({ open, close, reloadMeasurements, name, id }) => {
  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          overflow: 'hidden',
        },
      }}
    >
      {/* HEADER SECTION */}
      <Box
        sx={{
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: '#fff',
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: '10px',
              bgcolor: alpha('#0288d1', 0.1),
              color: 'info.main',
              display: 'flex',
            }}
          >
            <EditNoteOutlined fontSize="small" />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ lineHeight: 1.2 }}>
              Edit Measurement
            </Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              Updating: <span style={{ color: '#0288d1' }}>{name}</span>
            </Typography>
          </Box>
        </Stack>

        <IconButton
          onClick={close}
          size="small"
          sx={{
            bgcolor: alpha('#000', 0.05),
            '&:hover': { bgcolor: alpha('#d32f2f', 0.1), color: '#d32f2f' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* FORM CONTENT */}
      <DialogContent sx={{ p: 4 }}>
        <EditMeasurementForm closeModal={close} reload={reloadMeasurements} name={name} id={id} />
      </DialogContent>
    </Dialog>
  );
};

export default EditMeasurementModal;
